const TOKEN_KEY = "token";
const DATA_USER_KEY = "dataUser";

const StorageConfig = {
  _getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [key, ...valueParts] = cookie.split("=");
      if (key === name) {
        return decodeURIComponent(valueParts.join("="));
      }
    }
    return null;
  },

  _setCookie(name, value, maxAge) {
    let cookieStr = `${name}=${encodeURIComponent(value)}; Path=/; SameSite=Lax`;
    if (maxAge) {
      cookieStr += `; Max-Age=${maxAge}`;
    }
    document.cookie = cookieStr;
  },

  _deleteCookie(name) {
    document.cookie = `${name}=; Path=/; Max-Age=0; SameSite=Lax`;
  },

  getToken() {
    return this._getCookie(TOKEN_KEY);
  },

  saveToken(accessToken, maxAge) {
    this._setCookie(TOKEN_KEY, accessToken, maxAge);
  },

  getData() {
    return this._getCookie(DATA_USER_KEY);
  },

  saveData(data, maxAge) {
    this._setCookie(DATA_USER_KEY, data, maxAge);
  },

  clearSession() {
    this._deleteCookie(TOKEN_KEY);
    this._deleteCookie(DATA_USER_KEY);
  },
};

export default StorageConfig;
